import { Color, fullViewHeight } from "constants/styles"
import styled from "styled-components"

export const StyledSpinner = styled.div<{ isAbsoluteCentering: boolean }>`
  position: ${({ isAbsoluteCentering }) =>
    isAbsoluteCentering ? "absolute" : "relative"};
  width: 64px;
  height: 64px;
  border-radius: 50%;
  border: 4px solid ${Color.GREY_40};
  margin-bottom: 48px;
  ${({ isAbsoluteCentering }) => isAbsoluteCentering && "top: 50%"};

  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    inset: -4px;
    margin: auto;
    height: auto;
    width: auto;
    border: 4px solid ${Color.ACCENT};
    border-radius: 50%;
    animation: l20-1 0.8s infinite linear alternate, l20-2 1.6s infinite linear;
  }

  @keyframes l20-1 {
    0% {
      clip-path: polygon(50% 50%, 0 0, 50% 0%, 50% 0%, 50% 0%, 50% 0%, 50% 0%);
    }
    12.5% {
      clip-path: polygon(
        50% 50%,
        0 0,
        50% 0%,
        100% 0%,
        100% 0%,
        100% 0%,
        100% 0%
      );
    }
    25% {
      clip-path: polygon(
        50% 50%,
        0 0,
        50% 0%,
        100% 0%,
        100% 100%,
        100% 100%,
        100% 100%
      );
    }
    50% {
      clip-path: polygon(
        50% 50%,
        0 0,
        50% 0%,
        100% 0%,
        100% 100%,
        50% 100%,
        0% 100%
      );
    }
    62.5% {
      clip-path: polygon(
        50% 50%,
        100% 0,
        100% 0%,
        100% 0%,
        100% 100%,
        50% 100%,
        0% 100%
      );
    }
    75% {
      clip-path: polygon(
        50% 50%,
        100% 100%,
        100% 100%,
        100% 100%,
        100% 100%,
        50% 100%,
        0% 100%
      );
    }
    100% {
      clip-path: polygon(
        50% 50%,
        50% 100%,
        50% 100%,
        50% 100%,
        50% 100%,
        50% 100%,
        0% 100%
      );
    }
  }

  @keyframes l20-2 {
    0% {
      transform: scaleY(1) rotate(0deg);
    }
    49.99% {
      transform: scaleY(1) rotate(135deg);
    }
    50% {
      transform: scaleY(-1) rotate(0deg);
    }
    100% {
      transform: scaleY(-1) rotate(-135deg);
    }
  }
`

export const StyledSpinnerWrapper = {
  Wrapper: styled.div`
    ${fullViewHeight};
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
}
